<template>
  <i :class=myIconClass @click=onClick :title=popup />
</template>

<script>
import {iconClass} from "common"

export default {

  name: "Icon",
  
  props: {
    name: String,
    popup: String,
  },
  
  data()
  {
    return {
    }
  },
  
  emits: ["click"],
  
  methods: {
    onClick()
    {
      this.$emit("click")
    }
  },
  
  computed: {
    myIconClass()
    {
      return iconClass(this.name)
   },    
  },
}
</script>